import { render, staticRenderFns } from "./coachings.vue?vue&type=template&id=68212ee7&"
import script from "./coachings.vue?vue&type=script&lang=js&"
export * from "./coachings.vue?vue&type=script&lang=js&"
import style0 from "./coachings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports